import { getApps, initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBbyLZgxCHq4-kxCSmb5LT0FeSWm1ZbCg0",
  authDomain: "katapult-app-prototyp.firebaseapp.com",
  databaseURL:
    "https://katapult-app-prototyp-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "katapult-app-prototyp",
  storageBucket: "katapult-app-prototyp.appspot.com",
  messagingSenderId: "991393672560",
  appId: "1:991393672560:web:325df49fed52689b4e73b5",
};

if (!getApps().length) {
  initializeApp(firebaseConfig);
}

export const firebaseAuth = getAuth();
export const firebaseDB = getDatabase();
export const firebaseStorage = getStorage();
